var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filters"},[_c('img',{attrs:{"src":require("@/assets/img/filter.svg"),"alt":""}}),_vm._l((_vm.useList),function(filter){return _c('div',{key:filter.key,class:{ selected: _vm.inFilters(filter.key) },on:{"click":function($event){return _vm.selectFilter(filter)}}},[_vm._v(" "+_vm._s(filter.name)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }